import { Typography } from "@mui/material/styles/createTypography";

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const formatIndianCurrency = (amount: string | number): string => {
  if (amount === null || amount === undefined || amount === "") return "--";

  const num = Number(amount);

  if (isNaN(num)) return "--";

  const isNegative = num < 0;
  const absoluteAmount = Math.abs(num);

  const [int, dec] = absoluteAmount.toString().split(".");

  const lastThree = int.slice(-3);
  const other = int.slice(0, -3);

  const formattedInt = other
    ? other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
    : lastThree;

  const result = dec !== undefined ? `${formattedInt}.${dec}` : formattedInt;

  return isNegative ? `-${result}` : result;
};

export function formatWithCommas(value: string | number) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
